// directly called from head.php
export function initializeMaps() {
    const mapsElement = document.getElementById('googleMaps')

    if (!mapsElement) {
        return
    }

    const latlng = new google.maps.LatLng(52.3507401, 4.7598311);

    let drag = false;
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        drag = true;
    }

    const mapOptions = {
        featureType: "all",
        elementType: "labels",
        disableDoubleClickZoom: false,
        disableDefaultUI: false,
        scaleControl: true,
        panControl: false,
        navigationControl: true,
        mapTypeControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
            style: google.maps.ZoomControlStyle.LARGE
        },
        mapTypeControlOptions: {
            mapTypeIds: [
                google.maps.MapTypeId.ROADMAP,
                google.maps.MapTypeId.HYBRID
            ],
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
        },
        zoom: 15,
        center: latlng,
        scrollwheel: false,
        draggable: drag,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    const contentString = `
        <h4 style="line-height: 0;">Faringwell</h4>
        <p>Madridstraat 41, 1175 RK Lijnden<p>
        <a href="https://goo.gl/maps/kYuEyR1QcJmy7bpu5" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>
    `

    const map = new google.maps.Map(mapsElement, mapOptions)

    const infowindow = new google.maps.InfoWindow({
        content: contentString,
    });    

    const marker = new google.maps.Marker({
        position: latlng,
        map,
        title: "Faringwell",
    });

    marker.addListener("click", () => {
        infowindow.open(map, marker);
    });
}
